import { useRef, useState } from "react"
import PropTypes from "prop-types"
import { OfflineBolt, UnfoldLessSharp, UnfoldMoreSharp } from "@mui/icons-material"
import { Popover, IconButton, ListSubheader, List, ListItemButton, ListItemText } from "@mui/material"
import Tooltip from "components/material/tooltip"
import "./styles.scss"

export default function ExpansionMenu({ setExpansionMode, isExpanded, hasUnexpandedComposites, isLoading, disabled = false }) {
  const expansionRef = useRef()
  const [menuAnchor, setMenuAnchor] = useState(null)

  const handleOpenMenu = () => {
    setMenuAnchor(expansionRef.current)
  }

  const handleCloseMenu = () => {
    setMenuAnchor(null)
  }

  const showExpandedView = () => {
    setExpansionMode(true)
    handleCloseMenu()
  }

  const showCollapsedView = () => {
    setExpansionMode(false)
    handleCloseMenu()
  }

  const expansionText = (isExpanded && hasUnexpandedComposites) ? "Warning: one or more composite securities were not expanded" : "Choose expansion display..."

  let expansionIcon
  if (isExpanded && hasUnexpandedComposites) {
    expansionIcon = <>
      <OfflineBolt className="expansion-warning" />
      <UnfoldLessSharp />
    </>
  } else if (isExpanded) {
    expansionIcon = <UnfoldLessSharp />
  } else {
    expansionIcon = <UnfoldMoreSharp />
  }

  return <div className="components_expansion-menu">
    <Tooltip enterDelay={300} title={expansionText}>
      <IconButton
        ref={expansionRef}
        onClick={handleOpenMenu}
        className="expansion-button"
        size="large"
        loading={isLoading}
        disabled={disabled}
      >
        {expansionIcon}
      </IconButton>
    </Tooltip>

    <Popover
      anchorEl={menuAnchor}
      open={!!menuAnchor}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      classes={{
        root: "component_expansion-menu-dropdown",
      }}
    >
      <List className="expansion-menu">
        <ListSubheader component="div">Choose Expansion Display</ListSubheader>
        <ListItemButton key="display-expanded" className="expansion-menu-item" selected={isExpanded} onClick={showExpandedView}>
          <ListItemText
            primary="Expanded"
            secondary="Composite positions held in the portfolio &amp; where constituent data is available are expanded to show the underlying securities. Duplicate securities are aggregated, but can be de-aggregated with groups."
          />
        </ListItemButton>
        <ListItemButton key="display-collapsed" className="expansion-menu-item" selected={!isExpanded} onClick={showCollapsedView}>
          <ListItemText
            primary="Collapsed"
            secondary={<>All securities are displayed as one-level, with composite securities acting as atomic units. Calculations always ran on expanded view and may return composite effect. <i>Default</i></>}
          />
        </ListItemButton>
      </List>
    </Popover>
  </div>
}

ExpansionMenu.propTypes = {
  setExpansionMode: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  hasUnexpandedComposites: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}
